import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { DragSource, DropTarget } from 'react-dnd';
import flow from 'lodash/flow';
import { Resizable, ResizableBox } from 'react-resizable';
import Chip from '@material-ui/core/Chip';
import classNames from 'classnames';
import { Button } from '@material-ui/core';

import SnackbarContent from '@material-ui/core/SnackbarContent';

const style = {

};

function collectSource(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    };
}


class DraggableUnscheduledLesson extends Component {
    handleClick = () => {
    }

    render() {
        const { classes, lesson, isDragging, connectDragSource, connectDropTarget } = this.props;
        const opacity = isDragging ? 0 : 1;
        // console.log(card)

        // let backgroundColor = 'blue';
        // if (card.eventType === 'assignment') {
        //     backgroundColor = card.Color
        // }

        return connectDragSource(connectDropTarget(
            <div style={{ opacity, margin: '.5em', cursor: 'move' }}>
                <SnackbarContent
                    style={{ backgroundColor: lesson.Color }}
                    message={lesson.LessonName}
                    action={
                        <Button style={{ color: 'white' }} size="small" onClick={() => this.props.handleDelete(lesson)}>
                            DROP
                        </Button>
                    }
                />
            </div>
        ));
    }
}
const cardSource = {

    // beginDrag(props) {
    //     return {
    //         index: props.index,
    //         listId: props.listId,
    //         card: props.card
    //     };
    // },
    beginDrag(props) {
        return Object.assign({},
            {
                event: props.card,
                index: props.index,
                listId: props.listId,
                lesson: props.lesson

            },

            { anchor: 'drop' }
        )
    },

    endDrag(props, monitor) {
        // console.log(props, monitor)
        const item = monitor.getItem();
        const dropResult = monitor.getDropResult();
        if (!dropResult) {
            return null
        }
        if (dropResult && dropResult.listId !== item.listId) {
            // props.removeLesson(props.card.assignment_id, props.listId);
        }
        // console.log(props, monitor, dropResult)
        // if (!dropResult.target) {
        //     console.log('no target message')
        //     props.dropToCalendar(props.card)
        // }
    }
};

const cardTarget = {

    hover(props, monitor, component) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;
        const sourceListId = monitor.getItem().listId;
        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }

        // Determine rectangle on screen
        const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

        // Get vertical middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

        // Determine mouse position
        const clientOffset = monitor.getClientOffset();

        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;

        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%

        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }

        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }

        // Time to actually perform the action
        if (props.listId === sourceListId) {
            // console.log(dragIndex, hoverIndex, monitor.getItem());

            props.moveCard(dragIndex, hoverIndex, monitor.getItem().lesson);

            // props.prepareDisplayOrders()
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            monitor.getItem().index = hoverIndex;
        }
    }
};

export default flow(
    DropTarget("event", cardTarget, connect => ({
        connectDropTarget: connect.dropTarget()
    })),
    // DragSource("event", cardSource, (connect, monitor) => ({
    //     connectDragSource: connect.dragSource(),
    //     isDragging: monitor.isDragging()
    // }))
    DragSource("event", cardSource, collectSource)
)(DraggableUnscheduledLesson);



// WEBPACK FOOTER //
// src/main/content/course/builderComponents/DraggableUnscheduledLesson.js